/**
 * Words and small sums for the company Health tab (SF-5096).
 */
import type { CompanyUsage } from '../../../../components/usage/usageClient';

/**
 * The note shown when the company is not counted in platform usage; null when it is. The
 * figures are shown under it for every company (SF-5175: Demo and Test too, so we can see what a
 * demo is doing); they are left out of the platform totals by the API.
 */
export function notCountedNote(usage: CompanyUsage): string | null {
  if (usage.counted) return null;
  switch (usage.not_counted_reason) {
    case 'demo':
      return 'This company is not counted in platform usage (Demo). Its figures are shown below.';
    case 'test':
      return 'This company is not counted in platform usage (Test). Its figures are shown below.';
    case 'inactive':
      return 'This company is inactive, so it is not counted in platform usage. Its figures are shown below.';
    case 'internal':
      return 'ServeFirst Live: ServeFirst’s own company. It is never counted as a customer; the dashboard shows it on its own line.';
    default:
      return 'This company is not counted in platform usage.';
  }
}
